import { request } from "./client";
import type { TimeEventInput, TimeEventResponse } from "./types";

/** POST /api/v1/tawa/breaks/start — event_type = 'break_start'. */
export async function startBreak(
  body: TimeEventInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: "/breaks/start",
    data: body,
  });
}

/** POST /api/v1/tawa/breaks/end — event_type = 'break_end'. */
export async function endBreak(
  body: TimeEventInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: "/breaks/end",
    data: body,
  });
}
